import React from 'react';
import SimpleBar from 'simplebar-react';
import bgPattern from '../../../../assets/images/chat-bg-pattern.png';
import { MessageListProps } from '../interfaces';
import MessageItem from './messageItem';
import { MessagesSkeleton } from '../Skeletons';
import { shouldShowAgentBadge } from '../../utils/chat-helpers';

const MessageList: React.FC<MessageListProps> = ({
    messages,
    messagesLoading,
    messagesHasMore,
    loadMoreMessages,
    chatScrollRef,
    hasNewMessage,
    handleScrollToBottom,
    showScrollToTop,
    handleScrollToBottomFab,
    isInputDisabled,
    selectedContact,
    handleInitiateReply,
    handleReplyClick,
    resendMessage,
    getMediaUrl
}) => {
    return (
        <div
            className="chat-conversation flex-grow-1 position-relative"
            style={{
                backgroundImage: `url(${bgPattern})`,
                backgroundSize: '300px',
                backgroundRepeat: 'repeat',
                overflow: 'hidden',
                minHeight: 0,
                height: 0,
                flex: '1 1 auto'
            }}
        >
            {messagesLoading && messages.length === 0 ? (
                <MessagesSkeleton/>
            ) : (
                <SimpleBar
                    ref={chatScrollRef}
                    className="h-100 p-3 p-lg-4"
                >
                    {/* Load older messages */}
                    {messagesHasMore && (
                        <div className="text-center mb-3">
                            <button
                                className="btn btn-sm btn-light shadow-sm"
                                onClick={loadMoreMessages}
                                disabled={messagesLoading}
                            >
                                {messagesLoading ? (
                                    <span className="spinner-border spinner-border-sm me-1"
                                          role="status"></span>
                                ) : (
                                    <i className="ri-arrow-up-line me-1"></i>
                                )}
                                Cargar mensajes anteriores
                            </button>
                        </div>
                    )}

                    <ul className="list-unstyled chat-conversation-list">
                        {messages.map((message, index) => {
                            const isSentByMe = message.direction === 'outbound';
                            const prevMessage = index > 0 ? messages[index - 1] : null;
                            const isSameDirectionAsPrev = prevMessage ? prevMessage.direction === message.direction : false;
                            const isLastInClosedConv = message.conversationClosed && message.conversationClosedAt &&
                                (index === messages.length - 1 || messages[index + 1].conversationClosedAt !== message.conversationClosedAt);

                            const showBadge = shouldShowAgentBadge(prevMessage, message);

                            return (
                                <MessageItem
                                    key={message.id}
                                    message={message}
                                    isSentByMe={isSentByMe}
                                    isSameDirectionAsPrev={isSameDirectionAsPrev}
                                    isLastInClosedConv={!!isLastInClosedConv}
                                    showBadge={showBadge}
                                    isInputDisabled={isInputDisabled}
                                    selectedContact={selectedContact}
                                    handleInitiateReply={handleInitiateReply}
                                    handleReplyClick={handleReplyClick}
                                    resendMessage={resendMessage}
                                    hasPrevMessage={index > 0}
                                    messages={messages}
                                    getMediaUrl={getMediaUrl}
                                />
                            );
                        })}
                    </ul>
                </SimpleBar>
            )}

            {/* Floating "New Messages" button */}
            {hasNewMessage && (
                <button
                    className="btn btn-dark btn-sm shadow-lg new-messages-fab"
                    onClick={handleScrollToBottom}
                >
                    <i className="ri-arrow-down-line me-1"></i>
                    Ver mensajes nuevos
                </button>
            )}

            {/* Floating "Scroll to Bottom" button */}
            {showScrollToTop && (
                <button
                    className="btn btn-primary btn-sm rounded-pill"
                    onClick={handleScrollToBottomFab}
                    style={{
                        position: 'fixed',
                        bottom: '180px',
                        right: '29px',
                        zIndex: 1000,
                    }}
                >
                    <i className="ri-arrow-down-s-line fs-20 text-white"></i>
                </button>
            )}
        </div>
    );
};

export default MessageList;
